import React, { useState } from 'react';
import ListSwitch from "../../components/List/ListSwitch";
import GridTabFolding from "../../components/Grid/GridTabFolding";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheck, faFemale, faXmark} from "@fortawesome/free-solid-svg-icons";
import styles from "../../components/Grid/GridTabFolding.module.css";
import Filter from "../../components/Filter/Filter";
import {fetchWithFiltersLocal} from "../../services/FilterService";

const FilterTestPage = props => {
    const handleFilterSubmit = async (filters) => {
        const filterParams = Object.entries(filters)
            .filter(([key, value]) => value)
            .map(([key]) => +key);

        try {
            const response = await fetchWithFiltersLocal(filterParams, '/seances');
        } catch (error) {
            console.error('Erreur lors de la récupération des données filtrées:', error);
        }
    };


    return (
        <div className="content">
            <Filter
                data={[
                    { value: "1", label: "Séance 1" },
                    { value: "2", label: "Séance 2" },
                    { value: "3", label: "Séance 3" },
                    { value: "4", label: "Séance 4" },
                    { value: "5", label: "Séance 5" },
                    { value: "6", label: "Séance 6" },
                    { value: "7", label: "Séance 7" },
                    { value: "8", label: "Séance 8" },
                    { value: "9", label: "Séance 9" },
                    { value: "10", label: "Séance 10" }
                ]}
                title={"Type de séance"}
                onFilterSubmit={handleFilterSubmit}
            />
        </div>
    );
};

export default FilterTestPage;
